import React, { HTMLAttributes, ReactElement } from 'react';
import Link from 'atomic/link/link';

import './main-banner.desktop.scss';

import mainBanner from 'assets/images/homepage/ranking-2024.jpg';

const MainBannerDesktop: React.FC<HTMLAttributes<HTMLElement>> = (): ReactElement => (
    <div className="main-banner">
        <div className="main-banner__inner container">
            <Link href="https://ranking.opineo.pl/?utm_source=OPI&utm_medium=SG&utm_campaign=RankingOpineo2024" type="link" wrapper={true}>
                <img
                    src={mainBanner}
                    alt="Ranking 2024"
                    width="1197"
                    height="331"
                />
            </Link>
        </div>
    </div>
);

export default MainBannerDesktop;
